import { useMemo, useState } from "react";
import { CircleSlash } from "lucide-react";
import { Btn } from "@/components/Kit";

export function useRowSelection(items) {
  const [selected, setSelected] = useState(() => new Set());
  const ids = useMemo(() => items.map((i) => i.id), [items]);

  const toggle = (id) =>
    setSelected((prev) => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });

  const allChecked = ids.length > 0 && ids.every((id) => selected.has(id));
  const toggleAll = () =>
    setSelected(() => (allChecked ? new Set() : new Set(ids)));
  const clear = () => setSelected(new Set());

  const validSelected = useMemo(
    () => ids.filter((id) => selected.has(id)),
    [ids, selected]
  );

  return { selected, toggle, toggleAll, allChecked, clear, selectedIds: validSelected };
}

export function SelectCheckbox({ checked, onChange, testid }) {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      onClick={(e) => e.stopPropagation()}
      data-testid={testid}
      className="h-4 w-4 cursor-pointer accent-[#465B7F]"
    />
  );
}

export function BulkDeleteBar({ count, onDelete, testid }) {
  if (count === 0) return null;
  return (
    <div className="flex items-center justify-between border border-[#E3E8EE] border-b-0 bg-[#F4F1EC] px-4 py-2.5" data-testid={`${testid}-bar`}>
      <span className="font-mono-data text-sm text-[#1C1A17]">
        {count} seleccionado{count > 1 ? "s" : ""}
      </span>
      <Btn variant="danger" onClick={onDelete} data-testid={testid}>
        <CircleSlash size={15} /> Anular seleccionados
      </Btn>
    </div>
  );
}
